import * as React from "react";
function StandaloneIcon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path d="M13.6316 3.63159H1V21H18.8947V8.89475" stroke={props.color || "black"} strokeLinecap="round" />
            <path d="M8.89478 12.5789L21 1M21 1H15.2106M21 1V6.46053" stroke={props.color || "black"} strokeLinecap="round" />
        </svg>;
}
export default StandaloneIcon;